import React, { memo, MouseEvent } from 'react';
import classNames from 'classnames';
import Icon from 'atomic/icon';
import MenuInterface, { MenuKeys } from 'modules/shared/layout/menu/interfaces/menu.interface';

import './menu-link-mobile.scss';

interface MenuLinkMobileProps {
    name: string;
    url?: string;
    icon?: MenuInterface[MenuKeys.icon];
    image?: MenuInterface[MenuKeys.image];
    onClick?: () => void;
    isArrow?: boolean;
}

const MenuLinkMobile: React.FC<MenuLinkMobileProps> = ({
    name,
    url,
    icon,
    onClick,
    isArrow = false
}) => {
    const onLinkClick = (event: MouseEvent<HTMLAnchorElement>): void => {
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    };

    return (
        <a
            href={url}
            className={classNames('menu-link-mobile', {
                'menu-link-mobile--arrow': isArrow
            })}
            title={name}
            onClick={onLinkClick}
        >
            {icon && (
                <Icon
                    className="menu-link-mobile__icon"
                    name={icon}
                    size={24}
                    color="dark"
                />
            )}
            {name}
        </a>
    );
};

export default memo(MenuLinkMobile);
